// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"ddc50988","83":"4e4ee8ff","116":"4e4ee8ff","274":"4e4ee8ff","280":"4e4ee8ff","289":"4e4ee8ff","346":"c8b31a99","515":"4e4ee8ff","722":"31d6cfe0","831":"4e4ee8ff"}[chunkId] + ".chunk.css";
};